<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-07-16 13:49:42
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<!--
Author: TangChen
Date: 2018-11-06
Desc: 投资者信息补录，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="risk">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/risk' }">风险测评</el-breadcrumb-item>
                <el-breadcrumb-item>查看投资者信息补录</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-info-collection bizcomp ' + className">
            <inv-info />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import invInfo from "@/components/acctInfo/invInfoDc.vue";
export default {
    name: "InfoCollection",
    components: {
        invInfo
    },
    mixins: [mixin],
    data() {
        return {};
    },
    methods: {}
};
</script>
<style lang="scss">
/* 用户信息 */
.bizcomp-info-collection {
    padding-bottom: 30px;
}
</style>
